import $ from "jquery";
import EmblaCarousel from "embla-carousel";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "../styles/fancybox-brand.scss";

/**
 * Property page image strip slider with fixed image height and intrinsic widths.
 * Slides keep each image's natural aspect ratio via CSS (`height: 100%`, `width: auto`).
 */
function initPropertyGalleryStripEmbla(rootEl) {
  const $root = $(rootEl);
  const $viewport = $root.find(".property__gallery-strip__viewport");
  if (!$viewport.length) {
    return;
  }

  const embla = EmblaCarousel($viewport[0], {
    align: "start",
    containScroll: "keepSnaps",
    slidesToScroll: 2,
    dragFree: true,
    skipSnaps: true,
    loop: false,
    watchDrag: true,
  });

  const $prev = $root.find(".property__gallery-strip__arrow--prev");
  const $next = $root.find(".property__gallery-strip__arrow--next");

  const EDGE_EPS = 0.002;

  function syncArrowState() {
    // Prefer scroll progress (actual scroll bounds) so arrows match drag + snaps.
    const p = embla.scrollProgress();
    const canPrev = p > EDGE_EPS;
    const canNext = p < 1 - EDGE_EPS;
    $prev.prop("disabled", !canPrev).attr("aria-disabled", String(!canPrev));
    $next.prop("disabled", !canNext).attr("aria-disabled", String(!canNext));
    $prev.toggleClass("is-disabled", !canPrev);
    $next.toggleClass("is-disabled", !canNext);
  }

  $prev.on("click", () => embla.scrollPrev());
  $next.on("click", () => embla.scrollNext());

  embla.on("select", syncArrowState);
  embla.on("reInit", syncArrowState);
  embla.on("scroll", syncArrowState);
  embla.on("settle", syncArrowState);
  syncArrowState();

  // Slide widths are intrinsic (`img { width: auto; height: 100%; }`), so
  // we re-measure after images load to avoid stale snaps / clipped last slide.
  const $images = $root.find(".property__gallery-image");
  const whenMeasured = $images.get().map(
    (img) =>
      new Promise((resolve) => {
        if (img.complete && img.naturalWidth > 0) {
          resolve();
          return;
        }
        $(img).one("load error", resolve);
      }),
  );
  Promise.all(whenMeasured).then(() => {
    requestAnimationFrame(() => {
      embla.reInit();
      syncArrowState();
    });
  });

  requestAnimationFrame(() => {
    embla.reInit();
    syncArrowState();
  });

  Fancybox.bind(rootEl, '[data-fancybox="property-gallery-strip"]', {
    theme: "light",
    hideScrollbar: false,
    // Ensures brand CSS always targets the container (theme attr alone was unreliable in cascade).
    mainClass: "fancybox-brand",
  });
}

$(".property__gallery--strip").each(function initEachPropertyGalleryStrip() {
  initPropertyGalleryStripEmbla(this);
});
